import { computed, defineComponent, ref } from 'vue';
import { useSweetAlert } from '@/composables/sweetalert';
import { useStore } from 'vuex';
import { ProgressAction, ProgressGetter } from '@/store/progress/progress.module';
import { Progress, ProgressAttachment } from '@/store/progress/progress.model';
import BaseModalComponent from '@/components/baseModal/BaseModal.vue';

export default defineComponent({
  name: 'ProjectProgressAttachmentModalComponent',
  components: {
    BaseModalComponent
  },
  props: {
    projectId: {
      type: Number
    },
    progressId: {
      type: Number
    }
  },
  emits: [
    'upload',
  ],
  setup: (props, context) => {
    const swal = useSweetAlert();
    const store = useStore();
    const progress = computed<Progress>(() => store.getters[ProgressGetter.BY_ID](props.progressId));
    const attachments = computed<ProgressAttachment[]>(() => (progress.value) ? progress.value?.attachments.filter(m => m.attachmentType.id === 1) : []);
    const isLoading = computed<boolean>(() => store.getters[ProgressGetter.STATUS] === 'init' || store.getters[ProgressGetter.STATUS] === 'loading');
    const attachmentModal = ref<InstanceType<typeof BaseModalComponent>>();


    // show modal
    const show = () => {
      attachmentModal.value?.show();
    };

    // hide modal
    const hide = () => {
      attachmentModal.value?.hide();
    };

    // upload click
    const uploadClick = () => {
      context.emit('upload', props.progressId);
    };

    // delete click
    const deleleClick = (id: number) => {
      swal.confirm('ลบข้อมูล!', 'คุณต้องการลบข้อมูลใช่หรือไม่?', 'ใช่ ลบเดี๋ยวนี้!', '#dc3545')
        .then((result) => {
          if (result.isConfirmed) {
            store.dispatch(ProgressAction.REMOVE_ATTACHMENTS, {
              projectId: props.projectId,
              progressId: props.progressId,
              attachmentIds: [id],
            });
          }
        });
    };

    return {
      attachments,
      attachmentModal,
      isLoading,
      show,
      hide,
      uploadClick,
      deleleClick,
    };
  },
});
